/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';

import { ACCOUNT_ACTIVATION_EMAIL_SENT } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import trans from 'common/tools/translations/trans';

const AccountActivationEmailSentModal = ({ email, error }) => {
  const title = error
    ? trans('userspace.activation-email.error-modal.title')
    : trans('userspace.activation-email.success-modal.title');
  return (
    <ReactModal size="small" className="modal-welcome" title={title}>
      {error ? (
        <p>{trans('userspace.activation-email.error-modal.text1')}</p>
      ) : (
        <>
          <p
            className="vertical-spacing"
            dangerouslySetInnerHTML={{
              __html: trans('userspace.activation-email.success-modal.text1', {
                email
              })
            }}
          />
          <p>{trans('userspace.activation-email.success-modal.text2')}</p>
        </>
      )}
      <button
        type="button"
        className="button button-inverse-full js-trigger-overlay-close"
      >
        {trans('userspace.account-action.success.button-text')}
      </button>
    </ReactModal>
  );
};

AccountActivationEmailSentModal.propTypes = {
  email: PropTypes.string,
  error: PropTypes.bool.isRequired
};

AccountActivationEmailSentModal.defaultProps = {
  email: null
};

export default buildReactDomModalModule(
  ACCOUNT_ACTIVATION_EMAIL_SENT,
  (params = {}) => (
    <AccountActivationEmailSentModal
      email={params.email}
      error={params.error}
    />
  )
);
